<article class="library-card">
  <img class="library-card__image" [src]="imageUrl" alt="" aria-hidden="true" loading="lazy" />

  <div class="library-card__body">
    <div class="library-card__heading">
      <h3 class="library-card__title" [title]="library.name">{{ library.name }}</h3>

      @if (titlesCount !== null) {
        <span class="library-card__tag">{{ titlesCount }} {{ 'TITLES' | translate }}</span>
      }
    </div>

    <div class="library-card__actions">
      <a
        class="library-card__action"
        routerLink="/browse-index"
        [queryParams]="{ library: library.library_id }"
        [attr.aria-label]="('READ_MORE' | translate) + ' — ' + library.name"
      >{{ 'READ_MORE' | translate }}</a>
    </div>
  </div>
</article>
